webpackJsonp([18,35],{

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'switch',
	  props: {
	    showTag: {
	      type: Boolean,
	      default: false
	    },
	    tag: {
	      type: Array,
	      default: function _default() {
	        return ['开', '关'];
	      }
	    },
	    value: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    _handleClick: function _handleClick() {
	      this.stateSelf = !this.stateSelf;
	      this.$emit('on-click', this.stateSelf);
	      this.$emit('input', this.stateSelf);
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    }
	  },
	  computed: {
	    cssState: function cssState() {
	      var state = '';
	      if (this.showTag && !this.stateSelf) {
	        state = 'switch-tag-off';
	      } else if (!this.showTag && !this.stateSelf) {
	        state = 'switch-off';
	      } else {
	        state = 'switch-on';
	      }
	      return state;
	    }
	  },
	  watch: {
	    value: function value(newval) {
	      this.stateSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      stateSelf: this.value
	    };
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    class: [
	      _vm.showTag ? 'switch-tag' : '',
	      _vm.cssState
	    ],
	    on: {
	      "click": _vm._handleClick
	    }
	  }, [(_vm.showTag) ? _c('span', {
	    staticClass: "on"
	  }, [_vm._v(_vm._s(_vm.tag[0]))]) : _vm._e(), _vm._v(" "), (_vm.showTag) ? _c('span', {
	    staticClass: "off"
	  }, [_vm._v(_vm._s(_vm.tag[1]))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	var _boSwitch = __webpack_require__(16);
	
	var _boSwitch2 = _interopRequireDefault(_boSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    menuVertical: _menuVertical2.default,
	    BoSwitch: _boSwitch2.default
	  },
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    path: {
	      type: String,
	      default: ''
	    },
	    dock: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: Boolean,
	      default: false
	    },
	    alias: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    onclick: function onclick() {
	      this.$emit('on-click', '');
	    },
	    _handleSwitch: function _handleSwitch(data) {
	      var _this = this;
	
	      this.$emit('on-switch', {
	        obj: this,
	        state: data
	      });
	
	      setTimeout(function () {
	        _this.$refs.sw.setState(false);
	      }, 1000);
	    },
	    off: function off() {
	      this.$refs.sw.setState(false);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(35),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', {
	    attrs: {
	      "path": _vm.path
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    ref: "sw",
	    attrs: {
	      "state": _vm.state
	    },
	    on: {
	      "on-click": _vm._handleSwitch
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(255),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modal = __webpack_require__(76);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _demoswitch = __webpack_require__(27);
	
	var _demoswitch2 = _interopRequireDefault(_demoswitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DialogDemo',
	  components: {
	    Modal: _modal2.default,
	    Dmenu: _demoswitch2.default
	  },
	  methods: {
	    alert: function alert() {
	      this.type = 'alert';
	      this.show = true;
	    },
	    confirm: function confirm() {
	      this.type = 'confirm';
	      this.show = true;
	    },
	    open: function open() {
	      var _this = this;
	
	      this.$modal.open('test').$on('on-confirm', function () {
	        _this.$modal.close();
	      });
	    }
	  },
	  data: function data() {
	    return {
	      show: false,
	      show2: false,
	      type: 'alert'
	    };
	  }
	};

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('dmenu', {
	    attrs: {
	      "name": "Alert"
	    },
	    on: {
	      "on-switch": _vm.alert
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "Confirm"
	    },
	    on: {
	      "on-switch": _vm.confirm
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "Has child components"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.show2 = true
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "全局调用"
	    },
	    on: {
	      "on-switch": _vm.open
	    }
	  })], 1), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.show,
	      "type": _vm.type
	    },
	    on: {
	      "on-confirm": function($event) {
	        _vm.show = false
	      },
	      "on-cancel": function($event) {
	        _vm.show = false
	      }
	    }
	  }, [_vm._v("Hello world!")]), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.show2,
	      "type": _vm.type
	    },
	    on: {
	      "on-confirm": function($event) {
	        _vm.show2 = false
	      },
	      "on-cancel": function($event) {
	        _vm.show2 = false
	      }
	    }
	  }, [_c('input', {
	    staticClass: "input form-control",
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "placeholder": "请输入"
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.56a2d989ee03649acc51.js